"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALDAV_ERROR_MAP = exports.CALDAV_ERROR_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _CALDAV_ERROR_MAP;

var CALDAV_ERROR_TYPES = (0, _keyMirror.default)({
  GENERIC: null,
  NOT_FOUND: null,
  READ_ONLY: null,
  UNAUTHORIZED: null
});
exports.CALDAV_ERROR_TYPES = CALDAV_ERROR_TYPES;
var CALDAV_ERROR_MAP = (_CALDAV_ERROR_MAP = {}, (0, _defineProperty2.default)(_CALDAV_ERROR_MAP, CALDAV_ERROR_TYPES.UNAUTHORIZED, {
  errorType: CALDAV_ERROR_TYPES.UNAUTHORIZED,
  errorFields: ['username', 'password']
}), (0, _defineProperty2.default)(_CALDAV_ERROR_MAP, CALDAV_ERROR_TYPES.NOT_FOUND, {
  errorType: CALDAV_ERROR_TYPES.NOT_FOUND,
  errorFields: ['hostname']
}), (0, _defineProperty2.default)(_CALDAV_ERROR_MAP, CALDAV_ERROR_TYPES.GENERIC, {
  errorType: CALDAV_ERROR_TYPES.GENERIC,
  errorFields: []
}), (0, _defineProperty2.default)(_CALDAV_ERROR_MAP, CALDAV_ERROR_TYPES.READ_ONLY, {
  errorType: CALDAV_ERROR_TYPES.READ_ONLY,
  errorFields: ['username']
}), _CALDAV_ERROR_MAP);
exports.CALDAV_ERROR_MAP = CALDAV_ERROR_MAP;